
import { Controller } from '@hotwired/stimulus'

// usage:
//   render "application/forms/textarea_in_modal_editor_btn"
//   render "application/forms/textarea_in_modal_editor_modal"
export default class extends Controller {
  static outlets = [
    'bs--modal', // modal controller used in #open
  ]

  // triggered by a button
  open () {
    const input = this.element
      .closest('.input-group')
      .querySelector('input')
    const outlet = this.bsModalOutlet
    const modal = outlet.element
    const textarea = modal
      .querySelector("textarea")

    // set input id
    modal.dataset.inputId = input.id

    outlet.show()
    this._updateValue(input, textarea)
  }

  // triggered by closing modal
  close (e) {
    const modal = e.target
    const input = document.getElementById(modal.dataset.inputId)
    const textarea = modal.querySelector('textarea')

    this._updateValue(textarea, input)
  }

  // updates value from input to textarea (on modal open) and vice versa (on modal close)
  // preserving source selection and caret position
  _updateValue(source, target) {
    // replace whole text
    target.select() // setRangeText replace selection by default
    target.setRangeText(source.value)
    // restore selection
    target.selectionStart = source.selectionStart
    target.selectionEnd = source.selectionEnd
    // dispatch event
    target.dispatchEvent(new Event('input'))
    // set focus to target
    target.focus()
  }

}
